import { Box } from '@mui/material';
import React from 'react';
import { Log } from '../../../../models/log';
import { formatDateTime } from '../../../utils/dateUtils';
import { useIsConsultant } from '../../../utils/utilHooks';
import Controls from '../../controls/Controls';
import { GridTemplateSize, InlineGridTemplate } from '../../controls/Grid/InlineGridTemplate';

interface LogDialogDetailsProps {
  entity: Log;
}
export const LogDialogDetails: React.FC<LogDialogDetailsProps> = React.memo(
  (props) => {
    const { entity: value } = props;
    const isConsultant = useIsConsultant();

    return (
      <InlineGridTemplate size={['3fr', '2fr']} gap='18px' wrap={false} styleBox={{alignSelf: 'self-start'}} > 
        <Box>
          <Controls.Card title="Endringslogg" cardProps={{sx: {marginTop: '18px'}}}>
            <Box display="flex" flexDirection="column" component={'form'} >
              <Controls.InlineGridTemplate size={['7rem', '7rem']}>
                <Controls.TextField
                  label="Id"
                  type="number"
                  name="id"
                  value={value.id ?? ''}
                  readOnly
                  disabled
                />
                <Controls.TextField
                  label="GidId"
                  type="text"
                  name="gidId"
                  value={value.gidId ?? ''}
                  readOnly
                  disabled
                />
                <Controls.TextField
                  label="Bruker"
                  type="text"
                  name="Bruker"
                  value={value.bruker?.navn ?? ''}
                  readOnly
                  disabled
                />
                <Controls.TextField
                  label="Bruker"
                  type="text"
                  name="Bruker"
                  value={value.bruker?.navn ?? ''}
                  readOnly
                  disabled
                />
              </Controls.InlineGridTemplate>
              <Controls.DatePicker
                label="Dato"
                name="fraDato"
                value={value.fraDato ?? null}
                readOnly
                disabled
              />
              <Controls.TextField
                label={'Tidspunkt'}
                disabled={true}
                type="text"
                name="tidspunkt"
                sx={{ width: GridTemplateSize.datePicker }}
                value={value.tidspunkt ? formatDateTime(value.tidspunkt) : ''}
                readOnly
                
              />

              <Controls.InlineGridTemplate>
                <Controls.TextField
                  label="Applikasjon"
                  type="text"
                  name="applikasjon"
                  value={value.applikasjon ?? ''}
                  readOnly
                  disabled
                />

                <Controls.TextField
                  label="Modus"
                  type="text"
                  name="modus"
                  value={value.modus ?? ''}
                  readOnly
                  disabled
                />
              </Controls.InlineGridTemplate>

              <Controls.InlineGridTemplate>
                <Controls.TextField
                  label="Merknad"
                  type="text"
                  name="merknad"
                  value={value.merknad ?? ''}
                  readOnly
                  disabled
                />

                <Controls.TextField
                  label="Gruppe Id"
                  type="text"
                  name="gruppeLoggID"
                  value={value.gruppeLoggID ?? ''}
                  readOnly
                  disabled
                />
              </Controls.InlineGridTemplate>
            </Box>
          </Controls.Card>

          <Controls.Card title={'Diverse'}>
            <Controls.InlineGridTemplate>
              <Controls.TextField
                label="Type"
                type="text"
                name="type"
                value={value.type ?? ''}
                readOnly
                disabled
              />
              <Controls.TextField
                label="Funksjon"
                type="text"
                name="funksjon"
                value={value.funksjon ?? ''}
                readOnly
                disabled
              />
            </Controls.InlineGridTemplate>

            <Controls.InlineGridTemplate size={['7rem', '7rem']}>
              <Controls.TextField
                label="Element Id"
                type="text"
                name="elementId"
                value={value.elementId ?? ''}
                readOnly
                disabled
              />
              <Controls.TextField
                label="Filtype"
                type="text"
                name="filtype"
                value={value.filtype ?? ''}
                readOnly
                disabled
              />
              <Controls.TextField
                label="Tabellnavn"
                type="text"
                name="tabellNavn"
                value={value.tabellNavn ?? ''}
                readOnly
                disabled
              />
            </Controls.InlineGridTemplate>
          </Controls.Card>
        </Box>

        <Controls.Card title={'Feltverdier'} cardProps={{sx: {marginTop: '18px'}}}>
          <Box display="flex" flexDirection="column" >
            <Controls.TextField
              label=""
              type="text"
              multiline
              name="loggXML"
              value={value.loggXML ?? ''}
              readOnly
              disabled
            />
          </Box>
          <Box display="flex" flexDirection="column">
            <Controls.TextField
              label="Endret fra"
              type="text"
              multiline
              name="fraLoggXML"
              value={value.fraLoggXML ?? ''}
              readOnly
              hidden={!isConsultant}
            />
          </Box>
        </Controls.Card>
      </InlineGridTemplate>
    );
  }
);
